export default function contentfulToFastlyIo(contentfulImage, params) {
  let imagePath = contentfulImage.replace(/\/\/images.(ctfassets.net|contentful.com)/, "https://www.fastly.com/cimages")
  if (imagePath.includes(".svg")) {
    return imagePath
  }

  return `${imagePath}${params}`
}
